<div class="flyout-wrapper" [ngClass]="currentDeviceView" [class]="pageQuickPreview">
  <div class="preview-wrapper">
    @if (currentDeviceView === DeviceViewEnums.Desktop && !isNativeApp) {
      <div class="browser-header">
        <div class="dots-wrapper">
          <span (click)="flyoutService.close()" class="dot dot-1"></span>
          <span class="dot dot-2"></span>
          <span class="dot dot-3"></span>
        </div>
        <div class="text-wrapper">
          <span class="text">{{ "generic.preview" | translate }}</span>
        </div>
      </div>
    }
    <div
      class="preview"
      [style.height.px]="isTabletView ? null : currentDeviceView === WidgetDeviceView.Desktop ? 600 : 640"
      [ngClass]="currentDeviceView === DeviceViewEnums.Mobile ? 'smartphone' : isTabletView ? 'tablet' : 'desktop'">
      @if (!isLoading) {
        <div>
          <iframe
            [src]="iframeUrl"
            [width]="iframeWidth"
            [height]="iframeHeight"
            [style.transform]="iframeScale === 1 ? null : 'scale(' + iframeScale + ')'"></iframe>
          @if (showTemplatesNavigation) {
            @if (!isFirstTemplate) {
              <span type="button" class="previous-button" (click)="previousTemplate()">
                <i class="material-icons">arrow_back_ios</i>
              </span>
            }
            @if (!isLastTemplate) {
              <span type="button" class="next-button" (click)="nextTemplate()">
                <i class="material-icons">arrow_forward_ios</i>
              </span>
            }
          }
        </div>
      } @else {
        <div class="loading-container">
          <app-indeterminate-progress-dialog></app-indeterminate-progress-dialog>
        </div>
      }
    </div>
    <app-device-buttons (changedCurrentDeviceView)="changeCurrentDeviceView($event)"></app-device-buttons>
  </div>

  @if (isTemplatePreview && pageQuickPreview !== PageTitle.Editor) {
    <div class="template-details-wrapper">
      <div class="template-details">
        <div class="title">
          <div class="headline">{{ "generic.template" | translate | uppercase }}:</div>
          <div class="name">{{ templateName }}</div>
        </div>
        <div class="content-wrapper">
          <div class="content">
            @for (item of templateDescriptionItems; track item) {
              <div class="row">
                <img src="/assets/img/green-check.svg" class="checkmark" alt="" />
                <span [innerHTML]="item"></span>
              </div>
            }
          </div>

          <div class="author-column">
            <div class="author">
              <p>{{ "generic.author" | translate }}:</p>
              <a [href]="authorUrl" target="_blank">
                <img [src]="authorImage" class="logo" />
                <span class="name">{{ authorName }}</span>
              </a>
            </div>
          </div>
        </div>
      </div>
    </div>
  }
  <div class="preview-footer">
    <div class="btn-wrapper">
      <button class="underline-button" (click)="flyoutService.sidenav.close()">{{ "generic.close" | translate }}</button>
      @if (pageQuickPreview === PageTitle.Templates) {
        <button class="pick-button primary-button" mat-stroked-button (click)="pickTemplate()">
          <mat-icon>edit</mat-icon>
          {{ "generic.pick" | translate | uppercase }}
        </button>
      }
    </div>
  </div>
</div>
